import { useEffect, useState } from "react";

const usePreventBrowserNavigationOnScroll = (
  ref: React.RefObject<HTMLElement>
) => {
  const [isRefLoaded, setIsRefLoaded] = useState<boolean>(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsRefLoaded(true);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!ref.current || !isRefLoaded) return;

    const element = ref.current;

    const handleWheel = (event: WheelEvent) => {
      if (event.deltaX !== 0 && element) {
        const maxScrollLeft = element.scrollWidth - element.clientWidth;
        if (
          element.scrollLeft + event.deltaX < 0 ||
          element.scrollLeft + event.deltaX > maxScrollLeft
        ) {
          event.stopPropagation();
          event.preventDefault();
        }
      }
    };

    element.addEventListener("wheel", handleWheel, { passive: false });

    return () => {
      element.removeEventListener("wheel", handleWheel);
    };
  }, [ref, isRefLoaded]);
};

export default usePreventBrowserNavigationOnScroll;
